export const TextGeneralStylings = {
  color: "inherit",
  // rebrand-graphik: paragraph + utility text now uses Graphik (was Larsseit)
  fontFamily: "graphik",
  fontWeight: "normal",
  fontFeatureSettings: '"ss01" on, "ss02" on',
}

export const Text = {
  baseStyle: {
    ...TextGeneralStylings,
  },
  sizes: {
    xs: {
      fontSize: "0.625rem",
      lineHeight: 1.6,
    },
    sm: {
      fontSize: "0.75rem",
      lineHeight: 1.4,
    },
    smTight: {
      fontSize: "0.875rem",
      lineHeight: 1.4286,
    },
    md: {
      fontSize: "0.875rem",
      lineHeight: 1.4,
    },
    lg: {
      fontSize: "1rem",
      lineHeight: 1.4,
    },
    xl: {
      fontSize: "1.25rem",
      lineHeight: 1.4,
    },
  },
  variants: {
    mono: {
      fontFamily: "mono",
    },
    bold: {
      fontWeight: "bold",
    },
    medium: {
      fontWeight: "medium",
    },
    normal: {
      fontWeight: "normal",
    },
    larsseit: {
      fontFamily: "larsseit",
      fontWeight: "normal",
      letterSpacing: "-0.02em",
    },
    larsseitMedium: {
      fontFamily: "larsseit",
      fontWeight: "medium",
      letterSpacing: "-0.02em",
    },
    larsseitBold: {
      fontFamily: "larsseit",
      fontWeight: "bold",
      letterSpacing: "-0.02em",
    },
    productBadge: {
      fontSize: "0.875rem",
      lineHeight: 1.1429,
      fontWeight: "normal",
    },
    plpCardTitle: {
      fontFamily: "larsseit",
      fontSize: "0.875rem",
      lineHeight: 1.4,
      letterSpacing: "-0.02em",
      fontWeight: "normal",
      color: "text.primary",
    },
    productFragrances: {
      fontSize: { base: "0.75rem", md: "0.875rem" },
      lineHeight: { base: 1.6667, md: 1.7143 },
      fontWeight: "normal",
    },
  },
  defaultProps: {
    size: "md",
  },
}
